export default __webpack_public_path__ + "locales/el-GR/Settings.json?hash=faa604222cc9f5369c11e2d23b462487";